<template>
  <div v-if="!showRequest">
    <v-card class="fullForm">
      <div class="fullText">
        <h3>شرايط پرداخت کمک هزینه خرید اولین مسکن:</h3>
        <br />
        <b> الف - شرایط متقاضیان کمک هزینه خرید اولین مسکن</b>
        <br />
        <ol>
          <li>داشتن پرونده تحصيلي رسمی وفعال درمرکزمدیریت حوزه علميه خراسان</li>
          <li>داشتن شهریه رسمی حوزه علمیه</li>
          <li>متاهل بودن.</li>
          <li>سکونت با خانواده در منزل خریداری شده.</li>
          <li>اولین مسکن خریداری شده باشد. و بدهکار بودن بابت آن.</li>
          <li>
            سابقه دریافت حداقل 6 ماه کمک هزینه اجاره مسکن، یا داشتن سابقه 6 ماه
            اجاره درهنگام تقاضا و قبل از خرید مسکن.
          </li>
          <li>
            مالکیت حداقل سه دانگ (50%) ازمسکن خریداری شده به نام متقاضی باشد.
          </li>
          <li>
            متقاضیان کمک هزینه خرید اولین مسکن از تاریخ خرید مسکن و یا تحویل
            واحد مسکونی خود حداکثر یکسال فرصت دارند با احراز سایر شرائط مدارک
            لازم را ازطریق پورتال طلبگی خود ارائه نمایند.
          </li>
          <li>
            پیشرفت تحصیلی متناسب با برنامه آموزشی مصوب مرکز مدیریت حوزه علمیه
            خراسان برای طلاب در حال تحصیل در دروس مقدمات سطح1،سطح 2و سطح3 داشته
            باشند.
            <br />
            تبصره :شرط پیشرفت تحصیلی برای روحانیون 50 سال و بالاتر لازم الاجراء
            نیست.
          </li>
          <li>
            عدم اشتغال در ادارات ونهادهای حوزه ای، غیر حوزه ای وخصوصی ومشاغل
            آزاد.
          </li>
          <li>
            روحانیونی که همسر خود را طلاق داده و فرزند تحت سرپرستی خود داشته
            باشند با احراز شرائط مشمول دریافت کمک هزینه خرید اولین مسکن می شوند.
          </li>
        </ol>
        <br />
        <b>ب – مدارک و مستندات لازم کمک هزینه خرید اولین مسکن : </b>
        <br />
        <ol>
          <li>
            بارگذاري قولنامه و سند رسمي منزل خريداري شده. درصورتي كه قولنامه اي
            يا وكالتي است قولنامه خريدار و فروشنده مالك قبلي هم بارگذاري گردد.
          </li>
          <li>تایید درخواست متقاضی توسط ضامن ها .</li>
          <li>
            به مدارکی که مغایر با مقررات مندرج در این آیین نامه باشد ترتیب اثر
            داده نخواهد شد.
          </li>
        </ol>
        <br />
        <b>ج – پرداخت کمک هزینه خرید اولین مسکن :</b>
        <br />
        <ol>
          <li>
            کمک هزینه خرید اولین مسکن حداکثر به مدت چهل ماه با رقم ثابت قابل
            پرداخت می باشد.
          </li>
          <li>
            طلابی که کمک هزینه خرید اولین مسکن را دریافت نموده اند به هیچ وجه
            مجددا مشمول دریافت کمک هزینه اجاره و خرید مسکن نمی باشند.
          </li>
          <li>
            تحت هیچ شرائطی کمک هزینه اجاره مسکن و کمک هزینه خرید مسکن همزمان به
            یک فرد پرداخت نمی شود.
          </li>
          <li>
            تحقیقات محلی در خصوص خرید مسکن حسب ضرورت یا تشخیص اداره خدمات ویژه و
            یا کارگروه مسکن انجام می شود.
          </li>
        </ol>
        <br />
        <b>د – کمک هزینه خرید اولین مسکن فقط شامل طلابی است که از تاریخ
          01/01/1399 به بعد مسکن خریده باشند. و شامل طلابی که قبل از این تاریخ
          مسکن خریده اند نخواهد شد.
        </b>
      </div>
      <br />
      <br />

      <div style="width: 100%">
        <v-simple-checkbox v-model="showNext" :ripple="false"></v-simple-checkbox>
        <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
      </div>
    </v-card>
    <div class="confirm">
      <v-btn class="register" v-if="showNext" :class="!isMobile ? 'btnMargin' : ''" color="primary white--text" rounded
        @click="checkPermission" :disabled="apiRunning">
        {{ apiRunning ? "لطفا منتظر بمانید..." : "مرحله بعد" }}
      </v-btn>
    </div>
    <app-dialog @close="closeDialog"></app-dialog>
  </div>

  <div v-else>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> مبلغ خرید </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="amount" maxlength="13" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> کد طلبگی ضامن اول: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="guarantor1" maxlength="12" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> کد طلبگی ضامن دوم: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="guarantor2" maxlength="12" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>تاریخ قرارداد:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-btn class="form-center" color="orange white--text" rounded @click="onClickDate(1)">
            {{ startSelected ? startDate : "انتخاب تاریخ" }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>آدرس:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="address" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> تلفن: </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="phone" maxlength="11" :oninput="onInput" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row style="height: 135px !important">
        <v-col class="d-flex" :cols="12" sm="8">
          <v-file-input accept="image/*" label="پیوست مدارک" chips v-model="images" multiple></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register register2" rounded @click="applyRequest"
          :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
        </v-btn>
      </v-row>
    </v-card>
    <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
      min="1399/01/01" @change="onChangeDate($event, 1)"></date-picker>
    <input id="fileInput1" ref="fileInput1" />
  </div>
</template>

<script>
import { TODAY } from "@/utils/constants";
import moment from "moment-jalaali";
import Dialog from "@/components/Dialog";
import { saveBuyRequest, checkBuyApplyPermission } from "@/api/home-request";
export default {
  components: {
    appDialog: Dialog,
  },
  data() {
    return {
      showNext: false,
      showRequest: false,
      images: [],

      amount: "",
      guarantor1: "",
      guarantor2: "",
      startDate: TODAY,
      startSelected: false,
      address: "",
      phone: "",
      serial: "0",
    };
  },
  computed: {
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    active() {
      return this.$store.getters.currentHomeRequest;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    if (this.active.hasOwnProperty("FSerial")) {
      this.amount = this.active.Cash;
      this.guarantor1 = this.active.G1NumSys;
      this.guarantor2 = this.active.G2NumSys;
      this.address = this.active.Address;
      this.phone = this.active.Tel.trim();
      this.startDate = this.active.RentStartDate;
      this.startSelected = true;
      this.serial = this.active.FSerial;
      this.imgUrl = process.env.VUE_APP_API_ENDPOINT + this.active.DocPicUrl;
    }
  },

  methods: {
    closeDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    checkPermission() {
      checkBuyApplyPermission()
        .then((response) => {
          const data = response.data;
          if (data.Success) {
            window.scrollTo(0, 0)
            this.$router.push({
              query: {

                showRequest: "true"
              }
            });
          } else {
            this.$store.commit("SET_DIALOG_ICON", "exclamation");

            this.$store.commit("SET_DIALOG_TYPE", 0);

            this.$store.commit("SET_DIALOG_MESSAGE", data.Message);
            this.$store.commit("SET_DIALOG_SHOW", true);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (this.amount == "") {
        text = "مبلغ خرید نباید خالی باشد.";
      } else if (this.guarantor1 == "") {
        text = "ضامن اول بایستی انتخاب شود.";
      } else if (this.guarantor2 == "") {
        text = "ضامن دوم بایستی انتخاب شود.";
      } else if (!this.startSelected) {
        text = "لطفا زمان قرارداد را انتخاب کنید.";
      } else if (this.address == "") {
        text = "آدرس نباید خالی باشد.";
      } else if (this.phone == "") {
        text = " تلفن نباید خالی باشد.";
      } else if (this.images.length == 0) {
        text = "حداقل یک تصویر قولنامه بایستی انتخاب شود.";
      } else if (this.images.length > 5) {
        text = "حداکثر پنج تصویر  بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        saveBuyRequest(
          this.images,
          this.serial,
          this.guarantor1,
          this.guarantor2,
          this.startDate,
          this.amount,
          this.address,
          this.phone
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    /**
     * user changed date
     */
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },

    /**
     * check user input and  then send khorooj request
     */
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
      window.scrollTo(0, 0)
    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.register2 {
  width: 300px !important;
  margin: 20px auto;
}

.v-text-field__details {
  display: none;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}

.fullForm {
  margin-bottom: 65px;
}
</style>
